import app from "../_app";


export const openProductPopupHandler = (popup) => {
    const productPopup = document.querySelectorAll('.js-product-popup');
    if(productPopup) {
        app.lockBody();
        document.querySelector(`.js-product-popup[data-popup="${popup}"]`).setAttribute('data-open', '');
    }

};


const productPopup = [...document.querySelectorAll('.js-product-popup')];

if(productPopup) {
    const closeTriggers = [...document.querySelectorAll('.js-product-popup-close')];

    const closeProductPopupHandler = (e) => {
        e.currentTarget.closest('.js-product-popup').removeAttribute('data-open');

        app.unlockBody();
    };

    closeTriggers.map(closeTrigger => closeTrigger.addEventListener('click', closeProductPopupHandler));
}
